import React, {useEffect, useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../reducers";
import PageLayout from "../../components/layout/PageLayout";
import {useParams} from "react-router-dom";
import ErrorFormAlertView from "../../components/Common/ErrorFormAlertView";
import ErrorFormHelper from "../../utils/ErrorFormHelper";
import ErrorFormView from "../../components/Common/ErrorFormView";
import {ApiError} from "../../services/Api/types";
import handleException from "../../services/Api/handleException";
import {api} from "../../services/Api/api";

interface OwnProps {
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const QRCodePage = (props: Props) => {
    const {token} = useParams();
    const [errors, setErrors] = useState<ApiError[]>([]);
    const [saveLoading, setSaveLoading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [url, setUrl] = useState<string | undefined>(undefined);
    const [domain, setDomain] = useState("");
    const [type, setType] = useState("");
    const [number, setNumber] = useState("");
    const [error, setError] = useState<undefined | string>(undefined);

    const init = async () => {
        if (!token) {
            setError("QR Code nie istnieje");
            setLoading(false);
            return;
        }
        try {
            const response = await api.getQRCode(token);
            if (response) {
                if (response.redirect_url) {
                    setSuccess(true);
                    setUrl(response.redirect_url)
                }
                setLoading(false);
            } else {
                setError("QR Code nie istnieje")
                setLoading(false);
            }
        } catch (e: any) {
            const errors = handleException(e);
            setErrors(errors);
            setLoading(false);
        }
    }

    useEffect(() => {
        init();
    }, []);
    if (!token) return null;

    const save = async () => {
        setSaveLoading(true);
        if ((type === "DINE_IN" || type === "ROOM_SERVICE") && !number) {
            setErrors([
                {
                    field: "number",
                    code: "must_not_be_empty",
                    message: "Musisz wpisać numer"
                }
            ]);
            setSaveLoading(false)
            return;
        }
        try {
            const response = await api.createQRCode(token, domain, type, number);
            setSaveLoading(false);
            setSuccess(true);
            setUrl(response.redirect_url)
        } catch (e: any) {
            const errors = handleException(e);
            setErrors(errors);
            setSaveLoading(false);
        }
    }

    const renderLayout = (element: any) => {
        return (
            <PageLayout>
                <div style={{margin: "0 auto", maxWidth: 800}} className={"p-3"}>
                    {element}
                </div>
            </PageLayout>
        )
    }
    if (loading) {
        return (
            <>
                {renderLayout("Loading ...")}
            </>
        )
    }
    if (error) {
        return (
            <>
                {renderLayout(<div className={"alert alert-danger"}>{error}</div>)}
            </>
        )
    }
    return (
        <PageLayout>
            {renderLayout(
                <>
                    {success ? (
                        <>
                            <div>
                                <h4>
                                    Wygeneruj link dla QR Code: {token}
                                </h4>
                                <div className={"alert alert-success"}>
                                    Konfiguracja została ustawiona.
                                    Po zeskanowaniu QR Code zostaniesz przekierowany na URL: {` `}
                                    <a href={url}>{url}</a>
                                </div>
                            </div>
                        </>
                    ) : (
                        <>
                            <div>
                                <h4>
                                    Wygeneruj link dla QR Code: <strong>{token}</strong>
                                </h4>
                                <p>
                                    Do aktualnego QR Code <strong>https://store.goorder.pl/qr/{token}</strong> nie jest
                                    przypisana żadna akcja.
                                    Skonfiguruj odpowiednio aby QR Code zaczął działać.
                                </p>
                                <ErrorFormAlertView show_message={true} errors={errors}/>
                                <div className="form-group">
                                    <input type="text" onChange={(e) => setDomain(e.target.value)} value={domain}
                                           className={"form-control" + ErrorFormHelper(errors, "domain")}
                                           placeholder={`Domena *`}
                                           aria-label="Domena" aria-describedby="domain-name"/>
                                    <label htmlFor="cart-name">{`Domena *`}</label>
                                    <ErrorFormView errors={errors} field="domain"/>
                                </div>
                                <div className="form-group">
                                    <select value={type} onChange={(e) => setType(e.target.value)}
                                            className={"form-control" + ErrorFormHelper(errors, "type")} id={"type"}
                                            placeholder={type}>
                                        <option>Brak (domyślny)</option>
                                        <option value={"DINE_IN"}>Na miejscu / Stolik</option>
                                        <option value={"PICK_UP"}>Odbiór osobisty</option>
                                        <option value={"DELIVERY"}>Dostawa</option>
                                        <option value={"ROOM_SERVICE"}>Room service</option>
                                    </select>
                                    <label htmlFor="cart-name">{`Typ zamówienia`}</label>
                                    <ErrorFormView errors={errors} field="type"/>
                                </div>
                                {(type === "DINE_IN") && (
                                    <>
                                        <div className="form-group">
                                            <input type="text" onChange={(e) => setNumber(e.target.value)}
                                                   value={number}
                                                   className={"form-control" + ErrorFormHelper(errors, "number")}
                                                   placeholder={`Numer stolika *`}
                                                   aria-label="Numer stolika" aria-describedby="number-name"/>
                                            <label htmlFor="cart-name">{`Numer stolika *`}</label>
                                            <ErrorFormView errors={errors} field="number"/>
                                            <small>
                                                Numer stolika powinien odpowiadać numeracji stolików w aplikacji GoPOS.
                                                W przypadku błędnej wartości, zamówienie zostanie przypisane do złego
                                                stolika.
                                            </small>
                                        </div>
                                    </>
                                )}

                                {(type === "ROOM_SERVICE") && (
                                    <>
                                        <div className="form-group">
                                            <input type="text" onChange={(e) => setNumber(e.target.value)}
                                                   value={number}
                                                   className={"form-control" + ErrorFormHelper(errors, "number")}
                                                   placeholder={`Numer pokoju *`}
                                                   aria-label="Numer pokoju" aria-describedby="number-name"/>
                                            <label htmlFor="cart-name">{`Numer pokoju *`}</label>
                                            <ErrorFormView errors={errors} field="number"/>
                                        </div>
                                    </>
                                )}
                            </div>
                            <button
                                className={"btn-spinner btn-block btn-primary btn btn-submit mt-4" + (saveLoading ? ' loading' : '')}
                                onClick={() => {
                                    save()
                                }}>
                                <span className="left spinner-border spinner-border-sm"></span>
                                Zapisz
                            </button>
                        </>
                    )}
                </>
            )}
        </PageLayout>
    )
}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);

export default connector(QRCodePage);